export interface LoginAuthorizationModel {
    authentication_type: string;
    redirect_url: string;
    valid: boolean;
    validation_id: string;
    client_id: string;
    redirect_path: string;
    microsoft_multitenant: boolean;
    google_multitenant: boolean;
    error_code?: string;
    code_verifier?: string;
}

export enum AuthenticationType {
    Unknown = -1,
    Standard = 0,
    SSO,
}

export interface RefreshSSOTokenResponseModel {
    access_token: string;
    expiration: string;
    id_token?: string;
}

export class LoginAuthorization {
    static create(model: LoginAuthorizationModel): LoginAuthorization {
        const {
            authentication_type: authenticationTypeRaw,
            redirect_url: redirectUrl,
            valid,
            validation_id: validationId,
            client_id: clientId,
            redirect_path: redirectPath,
            microsoft_multitenant: microsoftMultitenant,
            google_multitenant: googleMultitenant,
            error_code: errorCode,
            code_verifier: codeVerifier
        } = model;

        let authenticationType;
        switch (authenticationTypeRaw.toLocaleLowerCase()) {
            case 'standard':
                authenticationType = AuthenticationType.Standard;
                break;
            case 'sso':
                authenticationType = AuthenticationType.SSO;
                break;
            default:
                authenticationType = AuthenticationType.Unknown;
        }

        return new LoginAuthorization(
            authenticationType,
            valid,
            redirectUrl,
            validationId,
            clientId,
            redirectPath,
            microsoftMultitenant,
            googleMultitenant,
            errorCode,
            codeVerifier
        );
    }

    static createFromSerializedData(
        serializedData: string
    ): LoginAuthorization | undefined {
        try {
            const data = JSON.parse(serializedData);
            const {
                authenticationType,
                valid,
                redirectUrl,
                validationId,
                clientId,
                redirectPath,
                microsoftMultitenant,
                googleMultitenant,
                errorCode,
                codeVerifier
            } = data;

            return new LoginAuthorization(
                authenticationType,
                valid,
                redirectUrl,
                validationId,
                clientId,
                redirectPath,
                microsoftMultitenant,
                googleMultitenant,
                errorCode,
                codeVerifier
            );
        } catch (e) {
            return;
        }
    }

    constructor(
        public readonly authenticationType: AuthenticationType,
        public readonly valid: boolean,
        public readonly redirectUrl: string,
        public readonly validationId: string,
        public readonly clientId: string,
        public readonly redirectPath: string,
        public readonly microsoftMultitenant: boolean,
        public readonly googleMultitenant: boolean,
        public readonly errorCode?: string,
        public readonly codeVerifier?: string
    ) { }

    public serialize(): string {
        const {
            authenticationType,
            valid,
            redirectUrl,
            validationId,
            clientId,
            redirectPath,
            microsoftMultitenant,
            googleMultitenant,
            errorCode,
            codeVerifier
        } = this;

        return JSON.stringify({
            authenticationType,
            valid,
            redirectUrl,
            validationId,
            clientId,
            redirectPath,
            microsoftMultitenant,
            googleMultitenant,
            errorCode,
            codeVerifier
        });
    }
}
